import React from 'react';
import { Link } from 'react-router-dom';

const styles = {
  container: {
    maxWidth: 700,
    margin: '40px auto',
    padding: '20px 30px',
    background: '#fff',
    borderRadius: 12,
    boxShadow: '0 6px 18px rgba(0,0,0,0.1)',
    fontFamily: 'Arial, sans-serif',
  },
  heading: {
    fontSize: '1.75rem',
    marginBottom: 20,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  benefit: {
    marginBottom: 12,
    fontSize: '1.1rem',
    lineHeight: 1.6,
  },
  note: {
    fontSize: '0.9rem',
    color: '#555',
    marginTop: 20,
    textAlign: 'center',
  },
  link: {
    color: '#2563EB',
    textDecoration: 'none',
  }
};

export default function MemberBenefits() {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Why Become a Member?</h1>
      <p style={styles.benefit}>✅ <strong>Unlimited Coins:</strong> Never worry about running out of coins again.</p>
      <p style={styles.benefit}>📨 <strong>Send Puzzle-Gift Invitations:</strong> Invite friends, family, and clients via mobile text or email.</p>
      <p style={styles.benefit}>📱 <strong>Access Contacts:</strong> Seamless access to your email or phone contacts for quick sharing.</p>
      <p style={styles.benefit}>🎁 <strong>Puzzle-Gift Store:</strong> Send puzzle-gift products and earn rewards via our Amazon affiliate program.</p>
      <p style={styles.benefit}>🚫 <strong>Ad-Free Experience:</strong> No third-party ads. Just fun.</p>
      <p style={styles.benefit}>🔓 <strong>Early Access:</strong> Be the first to try new puzzle styles, features, and seasonal games.</p>

      <p style={styles.note}>
        Already have an account? <Link to="/login" style={styles.link}>Login here</Link>.<br/>
        Ready to join? <Link to="/register" style={styles.link}>Create an account</Link> today!
      </p>
    </div>
  );
}
